import React from 'react';
import * as data from '../../data/featured_events'
import FeaturedEvent from './featuredEvent';
import FeaturedEventList from './featuredEventList';
import { Link } from 'gatsby'

class HomeFeaturedEvents extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      featuredEvents: {
        awards: {
          title: '',
          subtitle: '',
          events: [],
        },
        community_outreach: {
          title: '',
          subtitle: '',
          events: [],
        },
        dignitary_meetings: {
          title: '',
          subtitle: '',
          events: [],
        },
        interviews: {
          title: '',
          subtitle: '',
          events: [],
        },
        keynote_speeches: {
          title: '',
          subtitle: '',
          events: [],
        },
        videos: {
          title: '',
          subtitle: '',
          events: [],
        },
        volunteer_work: {
          title: '',
          subtitle: '',
          events: [],
        },
      },
      featuredEvent: {
        title: '',
        text: '',
        filename: '',
      },
      activeFilter: 'awards',
    };

    this.onFilterButtonClick = this.onFilterButtonClick.bind(this);
    this.onEventClick = this.onEventClick.bind(this);
  }

  componentDidMount() {
    this.setState({
      featuredEvents: data.default,
      featuredEvent: data.default.volunteer_work.events[0],
    });
  }

  onFilterButtonClick(e) {
    e.preventDefault();
    const filter = e.currentTarget.dataset.category;
    const { featuredEvents } = this.state;
    this.setState({
      activeFilter: filter,
      featuredEvent: featuredEvents[filter].events[0],
    });
  }

  onEventClick(eventId) {
    const { featuredEvents, activeFilter } = this.state;
    const newEvent = featuredEvents[activeFilter].events.find(ev => ev.id === eventId);
    this.setState({ featuredEvent: newEvent });
  }

  render() {
    const { featuredEvents, activeFilter, featuredEvent } = this.state;

    // Be sure to check out <a href=\"/events/\">the full event timeline</a>

    return (
      <div className="featured-events" id="featured">
        <div className="home-filter-buttons">
          <button className={ activeFilter === 'awards' ? 'featured-button-active' : ''} data-category="awards" onClick={this.onFilterButtonClick}>Awards</button>
          <button className={ activeFilter === 'community_outreach' ? 'featured-button-active' : ''} data-category="community_outreach" onClick={this.onFilterButtonClick}>Community Outreach</button>
          <button className={ activeFilter === 'dignitary_meetings' ? 'featured-button-active' : ''} data-category="dignitary_meetings" onClick={this.onFilterButtonClick}>Dignitary Meetings</button>
          <button className={ activeFilter === 'interviews' ? 'featured-button-active' : ''} data-category="interviews" onClick={this.onFilterButtonClick}>Interviews</button>
          <button className={ activeFilter === 'keynote_speeches' ? 'featured-button-active' : ''} data-category="keynote_speeches" onClick={this.onFilterButtonClick}>Keynote Speeches</button>
          <button className={ activeFilter === 'videos' ? 'featured-button-active' : ''} data-category="videos" onClick={this.onFilterButtonClick}>Videos</button>
          <button className={ activeFilter === 'volunteer_work' ? 'featured-button-active' : ''} data-category="volunteer_work" onClick={this.onFilterButtonClick}>Volunteer Work</button>
        </div>
        <div className="featured-title">
          <h3>{ featuredEvents[activeFilter].title }</h3>
          <p>{ featuredEvents[activeFilter].subtitle } Be sure to check out <Link to="/events/">the full event timeline</Link></p>
        </div>
        <div className="active-featured-events">
          <FeaturedEvent
            event={featuredEvent}
          />
          <FeaturedEventList
            activeId={featuredEvent.id}
            events={featuredEvents[activeFilter].events}
            onEventClick={this.onEventClick}
          />
        </div>
      </div>
    );
  }
}

export default HomeFeaturedEvents;
